// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"4c5e80e7","75":"4c5e80e7","85":"4c5e80e7","183":"f07fdd2f","651":"4c5e80e7"}[chunkId] + ".chunk.css";
};